const sellingPointsTitles = {
  lead: {
    title: 'Why is it useful for your company?',
    subtitle:
      'By handing over assignments to students for work, you free experienced employees from routine tasks, as well as increase brand awareness.',
  },
  chooseUs: {
    title: 'Why choose us?',
    subtitle:
      "We have built the largest IT company in Russia. We know how to develop cool employees, and we work hard to make our clients' lives better and happier.",
  },
};

export default sellingPointsTitles;
